import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { Subscription } from 'rxjs';
import { Station } from 'src/tmc-yard/client/model/station';
import { StationSet } from 'src/tmc-yard/client/model/station-set';
import { StationType } from 'src/tmc-yard/client/model/station-type.enum';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { SacClientContext } from '../../../model/sac-client.context';
import { SacClientService } from '../../../service/sac-client.service';
import { SuspendStationDialogComponent, SuspendStationDialogData } from '../sac-working-area/suspend-station-dialog/suspend-station-dialog.component';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';

@Component({
  selector: 'app-sac-station-item',
  templateUrl: './sac-station-item.component.html',
  styleUrls: ['./sac-station-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SacStationItemComponent implements OnInit, OnDestroy {

  latsUpdated: number;

  stationType = StationType;

  sacClientContext: SacClientContext;

  @Input() station: Station;
  @Input() stationSet: StationSet;
  @Input() selected: boolean = false;

  selectionSubscription: Subscription;

  style = 'default';
  background = 'none';

  @Input('sacClientContext') set setSacClientContext(sacClientContext: SacClientContext) {
    this.sacClientContext = sacClientContext;
    if (this.selectionSubscription != null) {
      this.selectionSubscription.unsubscribe();
    }


  }

  constructor(
    private dialog: MatDialog,
    private tmcContextService: TmcContextService,
    private sacClientService: SacClientService
  ) { }

  ngOnDestroy(): void {
    if (this.selectionSubscription != null) {
      this.selectionSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
  }

  public startSuspension() {
    const dialogData: SuspendStationDialogData = {
      stattionId: this.station.id
    };

    this.dialog.open(SuspendStationDialogComponent, {
      data: dialogData,
    }).afterClosed().subscribe(
      () => this.tmcContextService.forceRefreshOfStationUsages()
    );
  }

  public endSuspension() {
    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc-yard.widgets.sac-client.confirm.end-suspension.title',
      messageKey: 'tmc-yard.widgets.sac-client.confirm.end-suspension.message',
      confirm: () => {
        this.sacClientService.endStationSuspension({ id: this.station.id }).subscribe(
          result => {
            this.tmcContextService.forceRefreshOfStationUsages();
          }, error => {
            console.error('Error while ending station suspension', error);
            this.tmcContextService.forceRefreshOfStationUsages();
          }
        );
      }
    };

    this.dialog.open(ConfirmDialogComponent, { data: dialogData });
  }

}
